<template>
</template>
<script>
  export default {
    data() {
      let vm = this;
      return {
        element: null,
        resources: {
          zIndex: {
            name: 'zIndex',
            defaultValue: '',
            labelDesc: 'zIndex',
            callback: function () {
              vm.resources.zIndex.defaultValue = this.value;
              vm.element.internal_config.zIndex = this.value;

              vm.element.showThis();

            },
          },

          width: {
            name: 'width',
            defaultValue: '50',
            min: '20',
            max: '100',
            labelDesc: 'perc-size-video',
            callback: function () {
              vm.resources.width.defaultValue = this.value;
              vm.element.internal_config.width = this.value + '%';


              vm.element.showThis();
            },
          },

          backgroundColor: {
            name: 'backgroundColor',
            defaultValue: '#ffffff',
            gradient: true,
            labelDesc: 'bg-color-container',
            callback: function () {
              vm.resources.backgroundColor.defaultValue = this.colorValue;
              vm.element.internal_config.backgroundColor = this.colorValue;


              vm.element.showThis();
              vm.element.changeSideElements(this.colorValue)
            },
          },

          border: {
            name: 'border',
            defaultValue: '1px solid black',
            min: '0',
            max: '50',
            labelDesc: 'border',
            callback: function () {
              let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

              vm.resources.border.defaultValue = value;
              vm.element.internal_config.border = value;

              vm.element.showThis();
            },
          },

          borderRadius: {
            name: 'borderRadius',
            defaultValue: '0 0 0 0',
            min: '0',
            max: '360',
            labelDesc: 'borderRadius',
            callback: function () {

              let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

              vm.resources.borderRadius.defaultValue = value;
              vm.element.internal_config.borderRadius = value;


              vm.element.showThis();
            },
          },

          sizeIcon: {
            name: "sizeIcon",
            defaultValue: 15,
            min: 1,
            max: 50,
            labelDesc: "container-close-icon-size",
            callback: function() {
              vm.resources.sizeIcon.defaultValue = this.value;
              vm.element.internal_config.fontSize = this.value + 'px';

              vm.element.showThis();
            }
          },

          burguerMenuIcon: {
            name: 'burguerMenuIcon',
            defaultValue: 'mdi-close-circle-outline',
            labelDesc: 'container-close-icon',
            showAlign: false,
            canRemove : false,
            callback: function () {
              vm.resources.burguerMenuIcon.defaultValue = this.iconSelected;
              vm.element.internal_config.icon = this.iconSelected;

              vm.element.showThis();
            }
          },
          burguerMenuColor: {
            name: 'burguerMenuColor',
            defaultValue: '#ffffff',
            labelDesc: 'container-close-icon-color',
            callback: function () {
              vm.resources.burguerMenuColor.defaultValue = this.colorValue;
              vm.element.internal_config.color = this.colorValue;

              vm.element.showThis();
            }
          },

          padding: {
            name: 'padding',
            defaultLeft: '15',
            defaultTop: '15',
            defaultRight: '15',
            defaultBottom: '15',
            min: '0',
            max: '100',
            labelDesc: 'padding',
            callback: function () {
              vm.resources.padding.defaultLeft = this.l;
              vm.element.internal_config.paddingLeft = this.l + 'px';

              vm.resources.padding.defaultTop = this.t;
              vm.element.internal_config.paddingTop = this.t + 'px';

              vm.resources.padding.defaultRight = this.r;
              vm.element.internal_config.paddingRight = this.r + 'px';

              vm.resources.padding.defaultBottom = this.b;
              vm.element.internal_config.paddingBottom = this.b + 'px';


              vm.element.showThis();
            },
          },
        }
      }
    },
    methods: {
      setValuesData(data) {
        this.element = data;

        this.resources.border.defaultValue = data.internal_config.border;
        this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
        this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;

        this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
        this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
        this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
        this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

        this.resources.width.defaultValue = parseInt(data.internal_config.width);

        this.resources.sizeIcon.defaultValue = parseInt(data.internal_config.fontSize);
        this.resources.burguerMenuIcon.defaultValue = data.internal_config.icon;
        this.resources.burguerMenuColor.defaultValue = data.internal_config.color;

        this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;

        // console.log(this.resources.backgroundColor.defaultValue);

        // [
        //   {
        //     'name': translate-name-accordion,
        //     'showDesktop': true,
        //     'showMobile': true,
        //     'properties':[
        //       {
        //         'type': 'input'/check/color/image/icon/text-style,
        //         'lbl': 'se tiver ja passa traduzido',
        //         'helper': 'se tiver ja passa traduzido',
        //         warning: 'se tiver ja passa traduzido',
        //       },
        //       ...
        //     ]
        //   },
        //   ...
        // ]

      },
      getValuesData() {
        return this.resources;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/VideoGallery/Video/Resources.vue